import { Image } from "./Image";
import LeMagArticle from "./LeMagArticle";
import { List } from "./List";
import { Video } from "./Video";
import { VirtualController } from "./VirtualController";

export enum TipsType {
  APP_LAUNCH = "app_launch",
  APP_LOGIN = "login",
  GAME_LAUNCH = "game_launch",
  GAME_PLAY_BUTTON = "game_play_button",
}

export enum GameController {
  KEYBOARD_MOUSE = "keyboard / mouse",
  TOUCH_SCREEN = "touch screen",
  GAMEPAD = "gamepad",
  PARTIAL_GAMEPAD = "partial gamepad",
  MOUSE_ALONE = "mouse alone",
  REMOTE_CONTROL_AMAZON = "amazon remote control",
  REMOTE_CONTROL = "default remote control",
}

export enum Device {
  COMPUTER = "computer",
  PHONE = "phone",
  TABLET = "tablet",
  TV = "tv",
}
export declare type TipsMap = { [K in TipsType]?: GameTip[] };

export interface GameTip {
  id: string;
  text: string;
  title: string;
  kind?: "long_press" | "resolution";
  streamProtocols?: string[];
}

export interface GameGenre {
  id: string;
  title: string;
  uuid: string;
}

export enum GameStatus {
  INTEGRATION = "integration",
  DISABLED = "disabled",
  VALIDATION = "validation",
  LIVE = "live",
}

export enum PEGIRating {
  PEGI_3 = "3",
  PEGI_7 = "7",
  PEGI_12 = "12",
  PEGI_16 = "16",
  PEGI_18 = "18",
}

export type LanguageCode =
  | "ar-AR"
  | "bg-BG"
  | "cs-CZ"
  | "da-DK"
  | "de-DE"
  | "el-GR"
  | "en-US"
  | "es-ES"
  | "fi-FI"
  | "fr-FR"
  | "he-IL"
  | "hu-HU"
  | "it-IT"
  | "ja-JP"
  | "ko-KR"
  | "nl-NL"
  | "no-NO"
  | "pl-PL"
  | "pt-PT"
  | "ro-RO"
  | "ru-RU"
  | "sv-SE"
  | "th-TH"
  | "tr-TR"
  | "uk-UA"
  | "vi-VN"
  | "zh-ZH";

export interface Score {
  media: string;
  score: string;
  maxScore: string;
}

export interface AddonOption {
  bonusGameAddedAt: string;
  isAvailableForCurrentUser: boolean;
  isBonusGame: boolean;
  inGamePass: boolean;
  bonusGameUser?: { avatarID?: string; isMaster: boolean; nickname: string };
  bonusGameDaysLeft: number;
  isUbisoftProduct?: boolean;
  hasInAppPurchases?: boolean;
  userHasGamePass?: boolean;
}

export interface Game {
  id: string;
  images: Image[];
  videos: Video[];
  mainAdjectives: { id: string; label: string }[];
  name: string;
  slug: string;
  controllers?: GameController[];
  descriptionHtml?: string;
  developer?: { id: string; name: string };
  genres?: GameGenre[];
  maxGamepad?: number;
  pegiRating?: PEGIRating;
  blacknutRating?: PEGIRating;
  publisher?: { id: string; name: string };
  recommendations?: List[];
  devices?: Device[];
  multiPlayer?: boolean;
  online?: boolean;
  freeText?: string;
  virtualControllers?: VirtualController[];
  status?: GameStatus;
  videoHeight?: number;
  videoWidth?: number;
  newGame?: boolean;

  genre: string;
  createdAt: string;

  lemag?: LeMagArticle[];

  sessionDuration?: string;
  multiplayerTypes?: string[];
  difficulty?: string;
  difficultyId?: string;
  legal?: string;
  languages?: string[];
  scores?: Score[];
  languageTiedToAppLanguage?: boolean;
  languagesAudio?: string[];
  strEsrbRating?:
    | "early childhood"
    | "everyone"
    | "everyone 10+"
    | "teen"
    | "mature"
    | "adults only"
    | "rating pending";
  languagesCodes?: LanguageCode[];
  addonOption?: AddonOption;
  playedTimeLeft?: number;

  maintenance?: boolean;
  maintenanceReason?: string;
  biller?: {
    id: string;
    name: string;
  };
  gamePasses?: string[];
  userProfileRestriction?: boolean;

  /**
   * Life time in hours
   */
  lifetime?: number;
}
